import React, { Component } from "react";

import {
  Box,
  Button,
  Checkbox,
  Column,
  Columns,
  Control,
  Field,
  Input,
  TextArea,
  Title,
} from "@allxsmith/bestax-bulma";

import {formatDate} from "../../utils";

class OffHireSection extends Component {
  render() {

    /*
        Change on change function of off_hire_mileage (New Mileage) to run above function and set return as off_hire_excess_mileage
        The onChange function also needs to call a function that calculates mileage excess cost
    */


    const onQuoteReceivedTick = e => {
      let today = new Date();
      let data = {[e.target.name]: e.target.checked}
      if(e.target.checked){
        data['date_of_quote_received'] = formatDate(today);
      }
      else{
        data['date_of_quote_received'] = '';
      }
      this.props.triggerChange(data);
    }

    const onDamageIndicated = (damage) => {
      let today = new Date();
      let data = {"has_damage": damage};
      data['date_of_damage_indicated'] = formatDate(today);
      this.props.triggerChange(data);
    }

    // TODO(bestax-migrate): Form.Label became a plain element; the Bulma helper prop(s) `invisible` were dropped — restyle with classes
    return (
      <Box>
        <Title>Off Hire - To Be Completed on Vehicle Return</Title>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Off Hire Date</label>
              <Control>
                <Input
                  type="date"
                  name="off_hire_date"
                  onChange={this.props.onChange}
                  value={this.props.rental.off_hire_date || ""}
                />
              </Control>
            </Field>
          </Column>
          <Column>
                <label className="label">Off Hire Time</label>
                <Input
                    type={"time"}
                    value={this.props.rental.off_hire_time}
                    onChange={this.props.onChange}
                    name={"off_hire_time"}
                />
            </Column>
          <Column>
            <Field>
              <label className="label">New Mileage</label>
              <Control>
                <Input
                  type="number"
                  name="off_hire_mileage"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.off_hire_mileage)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Mileage Excess (over allowance)</label>
              <Control>
                <Input
                  type="number"
                  name="off_hire_excess_mileage"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.off_hire_excess_mileage)}
                  disabled={!this.props.rental.off_hire_excess_mileage_override}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Mileage Excess Override</label>
              <Control>
                <Checkbox
                  name="off_hire_excess_mileage_override"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.off_hire_excess_mileage_override}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <label className="label">Missing Fuel</label>
            <Checkbox
                checked={this.props.rental.missing_fuel}
                onChange={this.props.onCheck}
                name={"missing_fuel"}
            />
          </Column>
          <Column>
            <label className="label">Missing Fuel Litres</label>
            <Input
              value={this.props.rental.off_hire_fuel_litres}
              onChange={this.props.onChange}
              name={"off_hire_fuel_litres"}
            />
          </Column>
          <Column>
            <Field>
              <label className="label">Missing Fuel Charge</label>
              <Control>
                <Input
                  type="number"
                  name="off_hire_missing_fuel"
                  onChange={this.props.onChange}
                  disabled={!this.props.rental.missing_fuel}
                  value={String(this.props.rental.off_hire_missing_fuel)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <label className="label">Missing Ad Blue</label>
            <Checkbox
                checked={this.props.rental.missing_ad_blue}
                onChange={this.props.onCheck}
                name={"missing_ad_blue"}
            />
          </Column>
          <Column>
            <Field>
              <label className="label">Ad Blue Charge</label>
              <Control>
                <Input
                  type="number"
                  name="off_hire_ad_blue_charge"
                  onChange={this.props.onChange}
                  disabled={!this.props.rental.missing_ad_blue}
                  value={String(this.props.rental.off_hire_ad_blue_charge)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Mileage Excess Cost</label>
              <Control>
                <Input
                  type="number"
                  name="excess_mileage_charge"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.excess_mileage_charge)}
                  disabled={!this.props.rental.excess_mileage_charge_override}
                />
              </Control>
            </Field>
          </Column>
          <Column>
              <Control>
              <Field>
                <label className="label">Override</label>
                <Checkbox
                  name="excess_mileage_charge_override"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.excess_mileage_charge_override}
                />
              </Field>
            </Control>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Off Hire Total Additional Charges</label>
              <Control>
                <Input
                  type="number"
                  name="off_hire_total_additional_charges"
                  value={String(
                    this.props.rental.off_hire_total_additional_charges
                  )}
                  onChange={this.props.onChange}
                  disabled={!this.props.rental.off_hire_total_additional_charges_override}
                />
              </Control>
            </Field>
          </Column>
          <Column>
              <Control>
              <Field>
                <label className="label">Override</label>
                <Checkbox
                  name="off_hire_total_additional_charges_override"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.off_hire_total_additional_charges_override}
                />
              </Field>
            </Control>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Our Insurance</label>
                  <Button
                    color={this.props.rental.off_hire_insurance_completed  === "NOT_REQUIRED" ?  "primary" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_insurance_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_insurance_completed  === "NOT_DONE" ?  "danger" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_insurance_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_insurance_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_insurance_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Control>
              </Field>
          </Column>
          <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Tracker Access</label>
                  <Button
                    color={this.props.rental.off_hire_tracker_completed  === "NOT_REQUIRED" ?  "primary" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_tracker_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_tracker_completed  === "NOT_DONE" ?  "danger" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_tracker_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_tracker_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_tracker_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Control>
              </Field>
          </Column>
          <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Key Assigned</label>
                  <Button
                    color={this.props.rental.key_assigned ? "" : "danger"}
                    onClick={() => this.props.onChange({target: {name: "key_assigned", value: false}})}
                  >
                    Unassigned
                  </Button>
                  <Button
                    color={this.props.rental.key_assigned ? "success" : ""}
                    onClick={() => this.props.onChange({target: {name: "key_assigned", value: true}})}
                  >
                    Assigned
                  </Button>
                </Control>
              </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Has Damage</label>
                  <Button
                    color={this.props.rental.has_damage === "UNKNOWN"  ? "primary" : ""}
                    onClick={() => onDamageIndicated("UNKNOWN")}
                  >
                    Unknown
                  </Button>
                  <Button
                    color={this.props.rental.has_damage === "NO"  ? "success" : ""}
                    onClick={() => onDamageIndicated("NO")}
                  >
                    No
                  </Button>
                  <Button
                    color={this.props.rental.has_damage === "YES" ? "danger" : ""}
                    onClick={() => onDamageIndicated("YES")}
                  >
                    Yes
                  </Button>
                </Control>
              </Field>
          </Column>
          {this.props.rental.has_damage === "YES" ?
          <Column>
            <label className="label">Damage Indicated Date</label>
            <Input
              type={"date"}
              name={"date_of_damage_indicated"}
              value={this.props.rental.date_of_damage_indicated}
              onChange={this.props.onChange}
            />
          </Column> : <Column></Column>
          }
          <Column>
            <Columns isMultiline>
              <Column>
                <p>{this.props.rental ? this.props.rental.linked_quote_count : 0} Quotes linked to this rental</p>
              </Column>
              <Column>
                <label className="label">BLANK</label>
                <Button
                  color={"success"}
                  onClick={() => this.props.setQuoteModalOpen(true)}
                >
                  Create Quote +
                </Button>
              </Column>
              <Column>
                <label className="label">BLANK</label>
                <Button
                  color={"success"}
                  onClick={() => this.props.onDuplicate()}
                >
                  Duplicate Quote
                </Button>
              </Column>
            </Columns>
          </Column>
        </Columns>
        {this.props.rental.has_damage === "YES" &&
          <Columns isMultiline>
            <Column>
              <label className="label">Quote Received</label>
              <Checkbox
                name={"quote_received"}
                checked={this.props.rental.quote_received}
                onChange={onQuoteReceivedTick}
              />
            </Column>
            <Column>
              <label className="label">Quote Received Date</label>
              <Input
                type={"date"}
                name={"date_of_quote_received"}
                value={this.props.rental.date_of_quote_received}
                onChange={this.props.onChange}
              />
            </Column>
            <Column>
              <label className="label">Quote Amount</label>
              <Input
                name={"quote_amount"}
                value={this.props.rental.quote_amount}
                onChange={this.props.onChange}
              />
            </Column>
          </Columns>
        }
        <Columns isMultiline>
          <Column>
              <Control>
              <Field>
                <label className="label">Deposit Refunded</label>
                <Checkbox
                  name="deposit_refunded"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.deposit_refunded}
                />
              </Field>
            </Control>
          </Column>
          <Column>
            <label className="label">Deposit Refund Amount</label>
            <Input
                type={"number"}
                name={"deposit_refunded_amount"}
                value={this.props.rental.deposit_refunded_amount}
                onChange={(e) => this.props.onChange({target: {name: e.target.name, value: e.target.value}})}
            />
          </Column>
          <Column>
            <label className="label">Deposit Refund Date</label>
            <Input
                type={"date"}
                name={"deposit_refunded_date"}
                value={this.props.rental.deposit_refunded_date}
                onChange={(e) => this.props.onChange({target: {name: e.target.name, value: e.target.value}})}
            />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <label className="label">Off Hire Comments</label>
            <TextArea
              value={this.props.rental.off_hire_comments}
              onChange={this.props.onChange}
              name={"off_hire_comments"}
            />
          </Column>
        </Columns>
      </Box>
    );
  }
}

export default OffHireSection;
